import styled from "styled-components";

export const ErrorSummaryList = styled.ul`
  display: block;
  list-style-type: disc;
  padding-left: 2rem;
`;

export const ErrorSummaryListItem = styled.li`
  display: list-item;
  margin-bottom: 1rem;
`;
